import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Dropdown from './Dropdown';
import SegmentationChart from './SegmentationChart';

const cWidth = document.body.clientWidth - (24*16);

class VisualizeEvents extends Component {

  constructor(props) {
    super(props);

    this.state = {
      filter: 'all',
      segmentBy: false,
      chartWidth: cWidth
    };
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({
      chartWidth: document.body.clientWidth - (24*16)
    });
  }

  changeFilter = (evt) => {
    this.setState({
      filter: evt.target.value,
      segmentBy: false
    });
  }

  changeSegmentBy = (filtered) => (evt) => {
    const val = evt.target.value;
    this.setState({
      segmentBy: val === '-' ? false : {
        name: filtered.inputs[parseInt(val, 10)].name,
        index: parseInt(val, 10)
      }
    });
  }

  render() {
    const { contract, contractData } = this.props;
    const { filter, segmentBy, chartWidth } = this.state;

    const allEvents = contract.abi
      .filter(f => f.type === 'event')

    const events = allEvents
      .filter(f => filter !== 'all' ? f.name === filter : true);

    return (
      <section className="Main">
        <div className="Main-header">
          <h4>{contract.name} > Events</h4>
        </div>
        <div className="Main-filters">
          <div className="Main-left">
            <Dropdown
              title="Show"
              large
              options={[
                {text: 'All Events', value: 'all'},
                ...allEvents.map(e => ({text: e.name, value: e.name}))
              ]}
              onChange={this.changeFilter}
              value={filter}
            />

            {
              filter !== 'all' ? (
                <Dropdown
                  title="Segmented By"
                  large
                  options={[
                    {text: '-', value: '-'},
                    ...events[0].inputs.map((f, i) => ({
                      text: f.name,
                      value: i
                    }))
                  ]}
                  onChange={this.changeSegmentBy(events[0])}
                  value={segmentBy === false ? '-' : segmentBy.index}
                />
              ) : null
            }
          </div>
          <div className="Main-right">
            <Dropdown
              title="In the last"
              large
              options={[
                {text: '24 hours', value: 'hours'},
                {text: '3 days', value: '3days'},
                {text: 'week', value: 'week'}
              ]}
              value="hours"
            />
          </div>
        </div>
        <div className="Main-content">
          <SegmentationChart
            width={chartWidth}
            height='600'
            contract={contract}
            contractData={contractData}
            filter={filter}
            segmentBy={segmentBy}
            events
          />
        </div>
      </section>
    );
  }
}

VisualizeEvents.propTypes = {
  contract: PropTypes.object,
  contractData: PropTypes.object
};

export default VisualizeEvents;


// WEBPACK FOOTER //
// ./src/components/VisualizeEvents.js